import api from "../api";
import { API_URL } from "../constants";

export const getAlert = async (id: string) => {
  return api.get(`${API_URL}/v1/alert/${id}`);
};

export const getRecentAlert = async () => {
  return api.get(`${API_URL}/v1/alert/recent`);
};
